/* eslint-disable @typescript-eslint/no-unused-vars */
import './CarbonFootprintInfo.scss';
import download from '../../assets/download.svg';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import React from 'react';
import { View as viewContext } from '@twintag/twintag-core';
import { View } from '@esoptra/zaza-sdk';
import { Loader } from '@/components/blocks';
import PreviewModal from '../PreviewModal/PreviewModal';

const CarbonFootprintInfo = (props: any) => {
    const { t } = useTranslation();
    // const goto = (url: string) => {
    //     if (url) window.open(url, '_blank');
    // };

    const [reportURL, setReportURL] = React.useState<any>('');
    const [showLoader, setShowLoader] = React.useState(false);

    const onPreviewReportLetter = async () => {
        setShowLoader(true);
        const file = await getFileURL(
            props.metadata.$qid,
            props.metadata.report.FileQid
        );
        setReportURL(file.fileURL);
        setShowLoader(false);
    };

    const getFileURL = async (qid: string, fileQid: string) => {
        const view = new View(viewContext.getId());
        const obj = await view.object('metadata');
        const file: any = await obj.getFile(qid, fileQid);
        return file;
    };

    return (
        <>
            {showLoader && <Loader />}
            {reportURL && (
                <PreviewModal
                    url={reportURL}
                    name={props.metadata.report.Name}
                    onClose={() => setReportURL('')}
                    downloadText={props.translation('common.downloadBtn')}
                />
            )}

            <div className='infoDetails'>
                <div className='doc-details'>
                    <div className='displayGrid'>
                        <div className='heading'>
                            <h1 className='title'>
                                {t('calculate.title')}
                            </h1>
                        </div>
                        <div className='disflex'>
                            {props.metadata.scope && (
                                <div>
                                    <div className='label f-bold m-b-0-5'>
                                        {props.translation(
                                            'emission.labelScope'
                                        )}
                                    </div>

                                    <div className='inlinePad'>
                                        <ReactMarkdown>
                                            {props.metadata.scope}
                                        </ReactMarkdown>
                                    </div>
                                </div>
                            )}
                            {props.metadata.calculationMethodology && (
                                <div className='width-inline'>
                                    <div className='label f-bold m-b-0-5'>
                                        {t('calculate.calculationMethodology')}
                                    </div>
                                    <div className='data'>
                                        {
                                            props.metadata
                                                .calculationMethodology
                                        }
                                    </div>
                                </div>
                            )}
                            {props.metadata.productUnit &&
                                (props.metadata.type.toLowerCase() ===
                                    'product' ||
                                    props.metadata.type.toLowerCase() ===
                                    'produit') && (
                                    <div className='width-inline'>
                                        <div className='label f-w-600 m-b-0-5'>
                                            {t('title.funcUnit')}
                                        </div>
                                        <div className='data'>
                                            {props.metadata.productUnit}
                                        </div>
                                    </div>
                                )}
                            {props.metadata.productCarbonFootprint &&
                                (props.metadata.type.toLowerCase() ===
                                    'product' ||
                                    props.metadata.type.toLowerCase() ===
                                    'produit') && (
                                    <div className='width-inline'>
                                        <div className='label f-w-600 m-b-0-5'>
                                            {t(
                                                'title.productCarbonfootprint'
                                            )}
                                        </div>
                                        <div className='data'>
                                            {
                                                props.metadata
                                                    .productCarbonFootprint
                                            }
                                        </div>
                                    </div>
                                )}

                            {props.metadata.tCO2e &&
                                (props.metadata.type.toLowerCase() !==
                                    'product' ||
                                    props.metadata.type.toLowerCase() !==
                                    'produit') && (
                                    <div className='width-inline'>
                                        <div className='label f-bold m-b-1'>
                                            {t('calculate.tco2e')}:&nbsp;
                                            {props.metadata.tCO2e}
                                        </div>
                                        {props?.metadata?.emissionChart?.URL
                                            && (
                                                <div className='text-center'>
                                                    <img src={props?.metadata?.emissionChart?.URL} alt="" style={{ maxWidth: '100%', borderRadius: '20px' }} />
                                                </div>
                                            )}
                                    </div>
                                )}


                            {props.metadata.report && (
                                <div className='width-inline'>
                                    <div className='data'>
                                        <button
                                            className='advisorButton'
                                            onClick={() =>
                                                onPreviewReportLetter()
                                            }
                                        >
                                            {t('button.downloadReport')}
                                            <img src={download} alt='' />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CarbonFootprintInfo;
